// src/customerSurveyOptions.js
// مصدر الحقيقة لكل خيارات استبيان تصميم اللوحة — تُستخدم من CustomerSurveyForm.jsx,
// CustomerSurveyImagesAdmin.jsx و CustomerSurveyList.jsx. أي "key" هنا يُستخدم أيضًا
// كمعرّف وثيقة الصور المرجعية بمجموعة Firestore "surveyOptionImages".

export const PROJECT_TYPES = {
  residential: {
    label: "سكني",
    subtypes: ["شقة", "بيت", "فلة"],
  },
  commercial: {
    label: "تجاري",
    subtypes: [
      "مطعم",
      "كافيه",
      "فندق",
      "مركز تجميل",
      "صالون",
      "شركة",
      "مكتب هندسي",
      "عيادة",
      "أخرى",
    ],
  },
};

export const LOCATIONS = [
  "غرفة المعيشة",
  "غرفة النوم",
  "مكتب",
  "استقبال شركة",
  "مطعم أو كافيه",
  "فندق",
  "ممر أو مدخل",
  "مكان آخر",
];

export const FEELINGS = [
  "هدوء",
  "فخامة",
  "طاقة",
  "رومانسية",
  "غموض",
  "سعادة",
  "حنين",
  "أخرى",
];

export const ART_STYLES = [
  { key: "abstract", label: "الفن التجريدي" },
  { key: "cubism", label: "الفن التكعيبي" },
  { key: "islamic", label: "الفن الإسلامي (تراثيات، بغداديات)" },
  { key: "impressionism", label: "فن الانطباعية" },
  { key: "artnouveau", label: "فن الآرت نوفو" },
  { key: "vangogh", label: "فن فان كوخ" },
  { key: "baroque", label: "فن الباروك" },
  { key: "fantasy", label: "فن الخيال" },
  { key: "realism", label: "الفن الواقعي" },
  { key: "fauvism", label: "فن الوحشية" },
  { key: "surrealism", label: "الفن السريالي" },
  { key: "minimalism", label: "فن البساطة" },
  { key: "linear", label: "فن الخطوط" },
  { key: "futurism", label: "فن المستقبلية" },
  { key: "architecture", label: "فن العمارة الهندسية" },
  { key: "playful", label: "الفن المرح" },
];

export const COLORS = [
  { key: "white", label: "أبيض", hex: "#ffffff" },
  { key: "black", label: "أسود", hex: "#000000" },
  { key: "gray", label: "رمادي", hex: "#9e9e9e" },
  { key: "beige", label: "بيج", hex: "#e8dcc8" },
  { key: "brown", label: "بني", hex: "#795548" },
  { key: "gold", label: "ذهبي", hex: "#cfa93c" },
  { key: "silver", label: "فضي", hex: "#c0c0c0" },
  { key: "red", label: "أحمر", hex: "#d32f2f" },
  { key: "blue", label: "أزرق", hex: "#1565c0" },
  { key: "green", label: "أخضر", hex: "#2e7d32" },
  { key: "yellow", label: "أصفر", hex: "#f9a825" },
  { key: "pink", label: "وردي", hex: "#ec407a" },
];

export const ELEMENTS = [
  "طيور",
  "سماء",
  "جبال",
  "طبيعة",
  "بحر",
  "حصان",
  "وجوه",
];

export const PAINT_TYPES = [
  { key: "watercolor", label: "مائي" },
  { key: "acrylic", label: "اكرلك" },
  { key: "oil", label: "زيتي" },
];

export const BOARD_TYPES = [
  { key: "origin", label: "Origin" },
  { key: "edition", label: "Edition" },
  { key: "prime", label: "Prime" },
];

export const FRAME_OPTIONS = [
  { key: "classic_black", label: "كلاسيكي أسود" },
  { key: "classic_white", label: "كلاسيكي أبيض" },
  { key: "wood", label: "خشبي طبيعي" },
  { key: "gold", label: "ذهبي" },
  { key: "silver", label: "فضي" },
  { key: "modern_slim", label: "مودرن رفيع" },
  { key: "without_frame", label: "بدون إطار" },
];
